export default "__VITE_ASSET__e7a311ce__"